import * as React from "react";
const SvgTransparentCover = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 600, height: 600, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h600v600H0z", "data-name": "Rectangle 952", fill: "#dcdcdc", opacity: 0.65 }));
export default SvgTransparentCover;
